module.exports = __webpack_public_path__ + "static/media/eng_d_2055.93f11363.vtt";